module.exports = __webpack_public_path__ + "img/vital_signs_button.937fca30.jpg";